import { Pagination } from './graphQL-service-hook'

export const defaultPagination: Pagination = {
  limit: 5,
  page: 1,
}
